// DS2 — 카드 그리드(시안 .grid4): 4열 gap 20/16 · ≤760 2열 gap 16/12. cols=3 → 3열(≤760 2열) · cols=2 → 2열(≤760 1열).
// ds3 추가: cols=5 → 5열 gap 16/12(≤760 2열 · 카드가 딱 5장이면 5번째는 모바일에서 숨김 = 2×2).
// 열은 전부 minmax(0,1fr)(ds2_full 결정 1).
import type { ReactNode } from 'react';
import { slideAttrs } from './Bits';
import './ds2.css';

export interface SiteCardGridProps {
  children: ReactNode;
  cols?: 2 | 3 | 4 | 5;
  ariaLabel?: string;
  className?: string;
  /** ds4 — 목록 뿌리 <ul> 에 붙일 data-*(예: sortRootAttrs('upcoming') → data-ds4-sort). */
  dataAttrs?: Record<`data-${string}`, string>;
  /** region_home1b — 캐러셀 줄 안이면 li 마다 aria-roledescription="slide"(없으면 종전 마크업). */
  slides?: boolean;
}

/** children 은 카드들 — 각자 <li> 로 감싼다(key 는 children 의 key). */
export default function SiteCardGrid({ children, cols = 4, ariaLabel, className, dataAttrs, slides }: SiteCardGridProps) {
  const items = (Array.isArray(children) ? children.flat() : [children]).filter((c) => c !== null && c !== undefined && c !== false);
  const attrs: Record<string, string> = { ...(dataAttrs ?? {}) };
  if (cols !== 4) attrs['data-cols'] = String(cols);
  return (
    <ul className={className ? `ds2-grid ${className}` : 'ds2-grid'} aria-label={ariaLabel} data-ds2="card-grid" {...attrs}>
      {items.map((c, i) => {
        const k = (c as { key?: string | number | null })?.key;
        return <li key={k ?? i} {...(slides ? slideAttrs(i, items.length) : {})}>{c}</li>;
      })}
    </ul>
  );
}
